var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnlineWorkshops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.691,
    height: 64,
    viewBox: "0 0 57.691 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.691,
    height: 64,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.171,17.191C51.063,24.45,57.19,30.153,57.662,36.375c.471,6.175-4.713,12.868-10.653,18.147C41.117,59.848,34.424,63.807,27.637,64c-6.834.142-13.763-3.535-18.854-8.861a31.917,31.917,0,0,1-8.72-19.75A35.648,35.648,0,0,1,6.8,12.76C11.847,5.5,19.812-1,26.647.128c6.881,1.084,12.585,9.851,18.524,17.063",
    transform: "translate(0 0)",
    fill: "#0af"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M56.959,35c-1.839,0-3.636,1.28-5.015,3.669-1.744,3.023-2.909,7.9-2.909,13.4s1.165,10.374,2.909,13.4c1.379,2.389,3.177,3.67,5.015,3.67s3.636-1.281,5.015-3.67c1.744-3.023,2.909-7.9,2.909-13.4s-1.165-10.375-2.909-13.4C60.6,36.28,58.8,35,56.959,35m0,2.438c1.124,0,2.06.989,2.9,2.45,1.585,2.746,2.583,7.184,2.583,12.179s-1,9.433-2.583,12.179c-.843,1.46-1.778,2.45-2.9,2.45s-2.06-.989-2.9-2.45c-1.585-2.746-2.583-7.184-2.583-12.179s1-9.433,2.583-12.179c.843-1.46,1.778-2.45,2.9-2.45",
    transform: "translate(-28.113 -20.067)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.777,51.629c-.919-1.592-2.928-2.509-5.685-2.508-3.491,0-8.294,1.429-13.057,4.18s-8.4,6.2-10.148,9.218c-1.379,2.388-1.59,4.586-.671,6.178S35.144,71.205,37.9,71.2c3.491,0,8.294-1.429,13.057-4.18s8.4-6.2,10.148-9.218c1.379-2.388,1.59-4.586.671-6.178m-2.112,1.219c.561.973.173,2.279-.67,3.739-1.585,2.745-4.93,5.83-9.256,8.326S41.07,68.766,37.9,68.766c-1.686,0-3.011-.316-3.573-1.289S34.154,65.2,35,63.738c1.585-2.745,4.93-5.829,9.256-8.326s8.669-3.852,11.839-3.853c1.686,0,3.011.316,3.573,1.289",
    transform: "translate(-18.15 -28.163)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7,70.528a4.506,4.506,0,0,0,2.08-1.831c.919-1.592.709-3.79-.67-6.178C59.359,59.5,55.721,56.052,50.957,53.3S41.39,49.123,37.9,49.122c-2.758,0-4.766.916-5.685,2.508s-.709,3.789.67,6.177c1.747,3.023,5.385,6.468,10.148,9.218a30.976,30.976,0,0,0,11.125,4.052,1.219,1.219,0,1,0,.3-2.419,28.507,28.507,0,0,1-10.209-3.744c-4.326-2.5-7.671-5.582-9.256-8.326-.844-1.46-1.232-2.765-.67-3.739s1.887-1.29,3.573-1.289c3.17,0,7.513,1.355,11.839,3.853S57.408,61,58.993,63.74c.844,1.46,1.232,2.765.671,3.738a2.115,2.115,0,0,1-.989.836,1.219,1.219,0,1,0,1.02,2.214Z",
    transform: "translate(-18.15 -28.163)",
    fill: "#2b528e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.692,66.43a3.657,3.657,0,1,0,3.657,3.657,3.659,3.659,0,0,0-3.657-3.657m0,2.438a1.219,1.219,0,1,1-1.219,1.219,1.219,1.219,0,0,1,1.219-1.219",
    transform: "translate(-33.847 -38.087)",
    fill: "#02e2ff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineWorkshops);
export default __webpack_public_path__ + "static/media/online_workshops.92dcb5df058befbefa641322aece3483.svg";
export { ForwardRef as ReactComponent };